Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavSegments = void 0;

exports.getNavSegments = function (navigation, variation) {
  var nav = navigation.find(function (nav) {
    return nav.variation === variation;
  });

  if (!nav || !nav.segments || !Array.isArray(nav.segments)) {
    return [];
  }

  return nav.segments;
};